module.exports = [{"stylers":[{"hue":"#333"},{"saturation":-100}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":-50},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"invert_lightness":true},{"hue":"#ff003b"},{"saturation":-100},{"lightness":60}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"lightness":-4},{"gamma":0.78},{"saturation":0},{"hue":"#000"}]}]


//////////////////
// WEBPACK FOOTER
// /Users/terrymasher/Development/glenbeigh-ltd/src/map-styles/map-cobham-legacy.json
// module id = 521
// module chunks = 0 1